module.exports = {"511621001":"九龙街道","511621002":"朝阳街道","511621101":"花园镇","511621102":"坪滩镇","511621103":"龙孔镇","511621104":"镇裕镇","511621105":"白庙镇","511621106":"酉溪镇","511621107":"同兴镇","511621108":"兴隆镇","511621109":"秦溪镇","511621110":"顾县镇","511621111":"苟角镇","511621112":"天平镇","511621113":"石垭镇","511621114":"乔家镇","511621115":"罗渡镇","511621116":"裕民镇","511621117":"中和镇","511621118":"新场镇","511621119":"普安镇","511621121":"临溪镇","511621122":"西板镇","511621123":"齐福镇","511621124":"伏龙镇","511621212":"黄龙乡","511621216":"鱼峰乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511621.json
// module id = 2499
// module chunks = 0